import script from "./AddActionTaken.vue?vue&type=script&setup=true&lang=js"
export * from "./AddActionTaken.vue?vue&type=script&setup=true&lang=js"

import "./AddActionTaken.vue?vue&type=style&index=0&id=2e9b0f0b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9b0f0b"]])

export default __exports__